var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"tSoxIc0va6SRnQCUsRvGL"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs'
import { loadSentry } from './loadSentry'

const defaults = {
  SENTRY_DSN:
    process.env.SENTRY_DSN ||
    process.env.NEXT_PUBLIC_SENTRY_DSN ||
    'https://243d03dbea45462399d71335eb91d220@o268373.ingest.sentry.io/5784528',
  SCOPE: 'client',
  ENV: process.env.NEXT_PUBLIC_ENV || 'local'
}

loadSentry(defaults.SENTRY_DSN, {
  environment: defaults.ENV,
  tracesSampleRate: 1.0,
  integrations: [new Sentry.Replay({ maskAllText: false, blockAllMedia: false })],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
})
  .then(() => {
    console.log(`[Sentry (${defaults.SCOPE})] loaded successfully`)
  })
  .catch((error) => {
    console.log(`[Sentry (${defaults.SCOPE})] failed to load ${error}`)
  })
